import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { SubscriptionTermsConditionsModalComponent } from '../subscription-terms-conditions-modal/subscription-terms-conditions-modal.component';

/**
 * Componente SubscriptionCardComponent
 * Muestra información y ventajas sobre la suscripción mensual.
 * @component
 */
@Component({
  selector: 'app-subscription-card',
  standalone: true,
  imports: [CommonModule, SubscriptionTermsConditionsModalComponent],
  templateUrl: './subscription-card.component.html',
  styleUrl: './subscription-card.component.scss',
})
export class SubscriptionCardComponent {
  /**
   * Indica si se muestra el mensaje de suscripción (solo para pago mensual).
   * Convertido a signal input para prácticas modernas de Angular.
   */
  showSubscription = input(false);

  /**
   * Indica si esta tarjeta está seleccionada como método de pago.
   */
  isSelected = input(false);

  /**
   * Indica si hay promoción de puntos para mostrar.
   */
  showPromo = input(true);

  /**
   * Cantidad de puntos iniciales para la promoción.
   */
  promoPoints = input<number>(0);

  /**
   * Monto por cada punto en la promoción (ej: 1 punto por cada $800).
   */
  pointsPerAmount = input<number>(800);


  payWithCard = output<void>();

  /**
   * Indica si el botón está deshabilitado (como signal input).
   */
  disabled = input(false);

  /**
   * Controla la visibilidad del modal de términos y condiciones de suscripción.
   */
  isTermsModalVisible = false;

  /**
   * Abre el modal de términos y condiciones de suscripción.
   */
  openTermsModal(): void {
    this.isTermsModalVisible = true;
  }

  /**
   * Cierra el modal de términos y condiciones de suscripción.
   */
  closeTermsModal(): void {
    this.isTermsModalVisible = false;
  }

  /**
   * Maneja la aceptación de los términos y condiciones.
   */
  onTermsAccepted(): void {
    this.isTermsModalVisible = false;
  }
}
